module.exports = __webpack_public_path__ + "assets/cc38c44a7e6b8d3e573aa360f333de03.json";